import femaleBlessImage from 'assets/images/gender-female-bless-3-image.png'
import maleBlessImage from 'assets/images/gender-male-bless-3-image.png'

import { Cohort, Gender, PageVersions } from 'root-constants'
import { TPageVersion, TPartialMap, TPartialMapWithDefault } from 'root-types'

import { TGenderOption } from '../types'

const GENDER_OPTIONS_V1 = [
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.male',
    imageUrl: maleBlessImage,
  },
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.female',
    imageUrl: femaleBlessImage,
  },
] as const satisfies readonly TGenderOption[]

export const GENDER_OPTIONS_BY_VERSION = {
  [PageVersions.V1]: GENDER_OPTIONS_V1,
} as const satisfies TPartialMap<TPageVersion, readonly TGenderOption[]>

export const COHORT_TO_VERSION_MAP = {
  [Cohort.BP_BIBLE_2284]: PageVersions.V1,
  default: PageVersions.V1,
} as const satisfies TPartialMapWithDefault<Cohort, TPageVersion>
